import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from '../../../main/services';
import { Tender } from '../../models';
import { Offer } from '../../models/offer';

@Component({
    selector: 'jft-pdf-bif-analysis-report-modal',
    templateUrl: './pdf-bif-analysis-report-modal.component.html',
    styleUrls: ['./pdf-bif-analysis-report-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PdfBifAnalysisReportModalComponent implements OnInit {

    public loading: boolean = false;
    public file;
    public offers: Offer[] = [];
    public sumAwardedPercent: number;
    public isSendEmailPdf: boolean = true;
    public isSendNotificationPdf: boolean = false;
    public locationCount: number = 0;

    constructor(
        private tender: Tender,
        private toast: ToastService,
        private activeModal: NgbActiveModal,
        private route: ActivatedRoute,
    ) {
    }

    public ngOnInit() {
        let data = this.route.snapshot.data;
    }

    public setLocationCount(count: number) {
        this.locationCount = count;
    }


    public close() {
        this.activeModal.dismiss();
    }

    public submit() {
        this.activeModal.close({
            isEmail: this.isSendEmailPdf,
            isLink: this.isSendNotificationPdf,
        });
    }
}
